import IMemberUserRepository from "../../../domain/interfaces/repositories/IMemberUserRepository";
import { AuthOtpCodeUserRequest } from '../../../domain/entities/memberUser'

export const OtpCodeUserCommand = (
	repository: IMemberUserRepository,
	UserData: AuthOtpCodeUserRequest
) => {
	return repository.otpCode(UserData)
}
